import { FORMULA_TYPES } from 'constants/all';

import request from 'utils/request';

export default {
  compileFormula: async ({ formula, supplierId }) =>
    await request.post('/formula/compile/v2', {
      formula,
      type: FORMULA_TYPES.DISCOUNT,
      supplierId,
    }),
  create: async (groupId, data) =>
    await request.post(`/suppliers/${groupId}/discount_definitions`, data),
  delete: async (discountId) =>
    await request.delete(`/suppliers/discount_definitions/${discountId}`),
  get: async (discountId) =>
    await request.get(`/suppliers/discount_definitions/${discountId}`),
  list: async (groupId, params = {}) =>
    await request.get(`/suppliers/${groupId}/discount_definitions`, params),
  update: async (discountId, data) =>
    await request.patch(`/suppliers/discount_definitions/${discountId}`, data),
  updateFormula: async (discountId, formula, revertedFrom) =>
    await request.patch(
      `/suppliers/discount_definitions/${discountId}/formula`,
      {
        formula,
        revertedFrom,
      },
    ),
  updateVariable: async (variableId, data) =>
    await request.patch(`/formulas/variables/${variableId}`, data),
};
